import { render, staticRenderFns } from "./RequestReportDetailNew.vue?vue&type=template&id=1a37240a&scoped=true&"
import script from "./RequestReportDetailNew.vue?vue&type=script&lang=js&"
export * from "./RequestReportDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestReportDetailNew.vue?vue&type=style&index=0&id=1a37240a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37240a",
  null
  
)

export default component.exports